<template>
  <v-container fluid
  >
    <v-parallax
    :src="require('@/assets/citybridgenight.jpg')"
    height="600">
      <v-container fill-height>
        <v-layout align-center>
          <v-layout row wrap text-xs-center>
            <v-flex xs12>
              <h1 class="display-2 font-weight-thin white--text">Exicon ayuda a las empresas a acceder a capital.</h1>
              <h2 class="display-5 white--text">Para que puedan alcanzar sus objetivos estratégicos y financieros.</h2>
              <v-btn 
              color="success" 
              class="white--text"
              large
              :to="'/es/acerca'">Aprende Más</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-parallax>
    <v-layout row wrap
    >
      <v-flex xs12>
        <v-layout row wrap 
        text-xs-center
        justify-center            
        class="ma-5">
          <h1 class="display-2 font-weight-thin my-2">Nuestros servicios</h1>
          <h1 class="display-5 font-weight-thin my-2">Ayudamos a las empresas a lograr sus objetivos identificando socios estratégicos o inversores internacionales para una adquisición total o parcial de los activos de la compañía.</h1>
          <v-btn
          :to="'/es/contacto'">Contáctenos</v-btn>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-img
                    class="white--text"
                    height="200px"
                    :src="require('@/assets/handshakecolor.jpg')"
                  >
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="headline">Fusiones y Adquisiciones</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <v-card-title>
                    <div>
                      <span><strong>Adquisiciones totales o parciales: </strong> consolidación de la industria, nueva entrada en el mercado &amp; modernizar el negocio familiar.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                    flat
                    class="success--text"
                    :to="'/es/servicios'"
                    >Aprende Más</v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs12 sm6>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-img
                    class="white--text"
                    height="200px"
                    :src="require('@/assets/singaporecolor.jpg')"
                  >
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="headline">Aumento de Capital</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <v-card-title>
                    <div>
                      <span><strong>Acceda a los mercados financieros mundiales:</strong> inversión de crecimiento, reducción de costos, &amp; operaciones de modernización.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                    flat
                    class="success--text"
                    :to="'/es/servicios'"
                    >Aprende Más</v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-footer
      height="auto"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          accent
          pt-2
          text-xs-center
          black--text
          xs12
        >
          <p class="mx-3">Logre sus objetivos estratégicos y financieros con <strong>Exicon Investment Banking</strong></p>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      clients: [
        {
          name: 'Sonda (Chile)',
          img: 'sonda',
          sector: 'Info-Tec'
        },
        {
          name: 'Terpel (Colombia)',
          img: 'terpel',
          sector: 'Petróleo y Gas'
        },
        {
          name: 'Falabella (Chile)',
          img: 'falabella',
          sector: 'Al por Menor'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .carousel {
    height: 200px;
    width: 80%;
  }

  .client {
    position: absolute;
    bottom: 10px;
    background-color: rgba(0,0,0,0.5);
    color: white;
    font-size: 1.5em;
    padding: 20px;
  }
</style>






// WEBPACK FOOTER //
// src/components/bienvenido.vue